import { initializeApp } from 'firebase/app';
import { getAnalytics } from "firebase/analytics";
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAlqArl23yS0XR7SlrBo1_q2l6a2KMenbk",
  authDomain: "buddy-up-final.firebaseapp.com",
  projectId: "buddy-up-final",
  storageBucket: "buddy-up-final.appspot.com",
  messagingSenderId: "940674506577",
  appId: "1:940674506577:web:7e9cb7edc9b42f6c4fbd70",
  measurementId: "G-835409SBCV"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const auth = getAuth(app);
export const db = getFirestore(app);